import { render, staticRenderFns } from "./RequestReviewModal.vue?vue&type=template&id=1ca9e2a8&scoped=true&"
import script from "./RequestReviewModal.vue?vue&type=script&lang=js&"
export * from "./RequestReviewModal.vue?vue&type=script&lang=js&"
import style0 from "./RequestReviewModal.vue?vue&type=style&index=0&id=1ca9e2a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca9e2a8",
  null
  
)

export default component.exports